import { render } from "./FilterSectionHeader.vue?vue&type=template&id=b9610b92&scoped=true"
import script from "./FilterSectionHeader.vue?vue&type=script&lang=js"
export * from "./FilterSectionHeader.vue?vue&type=script&lang=js"

import "./FilterSectionHeader.vue?vue&type=style&index=0&id=b9610b92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9610b92"]])

export default __exports__